import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

//import './lib/jquery.event.move';
import 'hc-sticky/dist/hc-sticky';
import 'slick-carousel/slick/slick';
import 'lazysizes';
import './lib/smarticker';
import './lib/jQuery.print';
import 'waypoints/lib/noframework.waypoints';
//import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js"
import './lib/jquery.mousewheel';
import './lib/jquery.mCustomScrollbar';
import './lib/acmeticker';
//import 'malihu-custom-scrollbar-plugin';
import './modules/weather';
import 'owl.carousel/dist/owl.carousel';
import 'jquery.cookie';
//import gsap from "gsap";
// import Draggable from 'gsap/Draggable';


// gsap.registerPlugin(Draggable);


$(document).foundation();


(function ($) {

    var direction = $('html').css("direction").toLowerCase();
    var direction_opposite = $('html').css("direction").toLowerCase() === 'rtl' ? 'left' : 'right';
    var direction_boolean = $('html').css("direction").toLowerCase() === 'rtl';

    var engineUtils = {

        init: function () {
            this.ui.init();
        },

        ui: {

            init: function () {
                // engineUtils.ui.themeColor();
                engineUtils.ui.header();
                engineUtils.ui.headerWeather();
                engineUtils.ui.ticker();
                engineUtils.ui.lottie();
                engineUtils.ui.print();
                engineUtils.ui.jwplayerVideo();
                engineUtils.ui.layout();
                engineUtils.ui.plugins();
                engineUtils.ui.analytics();
                engineUtils.ui.cookies();
            },

            header: function () {

                var headerSticky = $(".header-sticky").hcSticky({
                    stickTo: 'body'
                });

                // menu on medium to small screen
                $(document).on('click', '.toggle-nav-panel', function (event) {
                    // Stop default action and bubbling
                    event.stopPropagation();
                    event.preventDefault();

                    $('.toggle-nav-panel').find('i').toggleClass('icon-menu icon-close');
                    //$('.toggle-nav-panel').toggleClass('is-active');
                    //$('.toggle-nav-panel').closest('#area-to-stick').toggleClass('open');
                    //$(this).parent(body).toggleClass('open');
                    $('html').toggleClass('opened');
                    //console.log("panel");
                    // Toggle the Slidebar with id 'id-4'

                    $('.toggle-search-panel').find('i').removeClass('icon-close').addClass('icon-search');

                    //$(".main-header-inner").css("background-color", "#253C3A");

                    $("#navpanel").fadeToggle("slow");

                    //controller.toggle('nav-panel');
                });

                // menu on medium to small screen
                $(document).on('click', '.toggle-mega-menu', function (event) {
                    // Stop default action and bubbling
                    event.stopPropagation();
                    event.preventDefault();

                    $(".mega-menu").fadeToggle("slow");
                });

                $(document).on('click', '.mega-menu__close', function (event) {
                    // Stop default action and bubbling
                    event.stopPropagation();
                    event.preventDefault();

                    $(".mega-menu").fadeToggle();

                    setTimeout(function () {
                        headerSticky.refresh();
                    }, 1000);
                });


                // search button on medium to small screen
                $(document).on('click', '.toggle-search-panel', function (event) {
                    // Stop default action and bubbling
                    event.stopPropagation();
                    event.preventDefault();

                    $('.toggle-search-panel').find('i').toggleClass('icon-search icon-close');
                    $('.toggle-search-panel').toggleClass('is-active');
                    //console.log("panel");
                    // Toggle the Slidebar with id 'id-4'

                    $('.toggle-nav-panel').find('i').removeClass('icon-close').addClass('icon-menu');

                    //controller.toggle('search-panel');
                });

                // Close ANY ================================================================
                $(document).on('click', '.dropdown-wrapper', function (event) { //.sb-opening
                    // if (controller.getActiveSlidebar()) {
                    //     event.preventDefault();
                    //     event.stopPropagation();
                    //     controller.close();
                    // }
                    $('.toggle-nav-panel').removeClass('is-active');
                    $('.toggle-nav-panel').find('i').removeClass('icon-close');
                    $('.toggle-nav-panel').find('i').addClass('icon-menu');

                    $('.toggle-search-panel').removeClass('is-active');
                    $('.toggle-search-panel').find('i').removeClass('icon-close');
                    $('.toggle-search-panel').find('i').addClass('icon-search');
                });

                $('.dropdown-wrapper button').on('click', function () {
                    $(this).next().toggleClass('expand');
                });
                $(document).keyup(function (e) {
                    if (e.keyCode == 27) { // escape key maps to keycode `27`
                        $('.dropdown-wrapper button').next().removeClass('expand');
                    }
                });
                $(document).on('click', function (event) {
                    if (!$(event.target).closest('.dropdown-wrapper').length) {
                        if ($('.dropdown-wrapper button').next().is(":visible")) {
                            $('.dropdown-wrapper button').next().removeClass('expand');
                        }
                    }

                    if ($(".account-menu").length) {
                        var container = $(".account-menu");
                        if (!container.is(event.target) && container.has(event.target).length === 0) {
                            $("#user-dropdown").prop("checked", false);
                            $("#user-dropdown-2").prop("checked", false); //to uncheck
                            $("body").removeClass("user-open");
                        }
                    }
                });
            },

            headerWeather: function () {
                // ========================  START: GET WEATHER AND DATE - HEADER AREA ===========================//

                function getLocation() {
                    let opts = {
                        enableHighAccuracy: false,
                        timeout: 1000 * 10, //10 seconds
                        maximumAge: 1000 * 60 * 5, //5 minutes
                    };
                    //navigator.geolocation.getCurrentPosition(app.fetchWeather, app.error, opts); 
                    navigator.geolocation.getCurrentPosition(location, locationError, opts);
                }

                function location(position) {
                    let lat = position.coords.latitude
                    let lon = position.coords.longitude

                    //for current weather data
                    weather(lat, lon);
                }

                function locationError(err) {
                    //geolocation failed
                    //console.error(err, 'allow browser location');
                    //if failed change to Riyadh location
                    location(
                        {
                            "coords":
                                { "latitude": 24.774265, "longitude": 46.738586 }
                        }
                    )
                }

                // function ipApi() {
                //     let myIP, city;

                //     $.ajaxSetup({ async: false });
                //     $.get('https://ipapi.co/json/', function (data) {
                //         myIP = data.ip;
                //         city = data.city;
                //         weather(data.latitude, data.longitude, city);
                //     }).fail(function () {
                //         let lat = 24.774265;
                //         let lon = 46.738586;
                //         city = "Riyadh";

                //         weather(lat, lon, city);
                //     });
                // }

                function weather(lat, lon, cty) {
                    let latitude = lat;
                    let longitude = lon;
                    let city = cty;

                    // get language based on website theme
                    var language = $('html').attr('lang');
                    //var city = myCity;
                    var key = 'e6b2733d76a61ac95b9dc3696049f189';

                    if (language == 'ur') {
                        language = 'ar'
                    }

                    // using city from ipapi
                    //var $url_weather = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${key}&lang=${language}&units=metric`
                    var $url_weather = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${key}&lang=${language}&units=metric`;

                    $.getJSON($url_weather, function (weatherData) {
                        var $weatherIcon;
                        var $myCity = weatherData.name;
                        var $myTemp = Math.trunc(weatherData.main.temp);
                        var $TempDesc = weatherData.weather[0].description;
                        var $currentWeather = weatherData.weather[0].main;

                        if ($currentWeather == 'Thunderstorm') {
                            $weatherIcon = "lightnight";
                        } else if ($currentWeather == 'Drizzle') {
                            $weatherIcon = "rain";
                        } else if ($currentWeather == 'Rain') {
                            $weatherIcon = "rain";
                        } else if ($currentWeather == 'Snow') {
                            $weatherIcon = "snow";
                        } else if ($currentWeather == 'Clouds') {
                            $weatherIcon = "cloudy";
                        } else if ($currentWeather == 'Dust' || $currentWeather == 'Fog' || $currentWeather == 'Haze') {
                            $weatherIcon = "wind";
                        } else {
                            $weatherIcon = "weather";
                        }

                        var html = '';

                        html += '    <div class="weather">' +
                            '       ' + $myCity + '  <span class="font-bold"> &#8451; <span class="wtemp">' + $myTemp + '</span> ' +
                            '       </span>' +
                            '        <span class="capitalize">' +
                            '            <i class="icomoon-icon icon-' + $weatherIcon + '"></i> ' + $TempDesc + ' ' +
                            '        </span>' +
                            '    </div>';

                        if (Foundation.MediaQuery.is('large') == true) {
                            $('#weather_today').replaceWith(html);
                        } else {
                            $('#weather-panel').replaceWith(html);
                        }
                    });
                }

                getLocation(); // location using geolocation
                //ipApi(); // location using ipapi

                // ========================  END: GET WEATHER AND DATE - HEADER AREA ===========================// 

            },

            ticker: function () {
                // smarticker 
                $('#news-ticker').smarticker({
                    theme: 2,
                    controllerType: 2,
                    animation: 'slide',
                    pausetime: 5000,
                    shadow: false,
                    progressbar: false,
                    googleFont: false,
                    catcolor: true,
                    subcatcolor: true,
                    subcategory: true
                });

                // ========================  START:  ACME NEWSTICKER  ===========================//
                $('.my-news-ticker-1').AcmeTicker({
                    type: 'horizontal',/*horizontal/horizontal/Marquee/type*/
                    speed: 1000,
                    direction: 'left',/*up/down/left/right*/
                });
                $('.my-news-ticker-2').AcmeTicker({
                    type: 'marquee',/*horizontal/horizontal/Marquee/type*/
                    direction: 'right',/*up/down/left/right*/
                    speed: 0.05,/*true/false/number*/ /*For vertical/horizontal 600*//*For marquee 0.05*//*For typewriter 50*/

                });
                $('.my-news-ticker-3').AcmeTicker({
                    type: 'typewriter',/*horizontal/horizontal/Marquee/type*/
                    direction: 'left',/*up/down/left/right*/
                    speed: 50,/*true/false/number*/ /*For vertical/horizontal 600*//*For marquee 0.05*//*For typewriter 50*/

                });
                $('.my-news-ticker-4').AcmeTicker({
                    type: 'vertical',/*vertical/horizontal/Marquee/type*/
                    direction: 'left',/*up/down/left/right*/
                    speed: 1000,
                });
                // ========================  START:  ACME NEWSTICKER  ===========================//

            },

            lottie: function () {
                // ========================  START:  LOTTIE  ===========================//

                if ($(".lottie-check").length) {
                    var btnList = document.querySelectorAll(".lottie-check");

                    Array.from(btnList).forEach(item => {
                        var animation2 = bodymovin.loadAnimation({
                            container: item,
                            render: "svg",
                            loop: false,
                            autoplay: false,
                            path: "assets/img/json/plus-to-checkmark.json"
                        });
                        //console.log(item, 'item');

                        item.addEventListener('click', () => {
                            if (item.classList.contains('on')) {
                                item.classList.remove('on');
                                animation2.stop();
                            }
                            else {
                                item.classList.add('on');
                                animation2.play();
                            }
                        })
                    })
                }
                // ========================  START:  LOTTIE  ===========================//
            },



            print: function () {
                // ========================  START:  PRINT ARTICLE ===========================//
                if ($(".print-btn").length) {
                    var baseUrl = window.location.origin;
                    $(document).on('click', '.print-btn', function (ev) {
                        ev.preventDefault();
                        var divToPrint = $(this).closest('.entry-article').find('.printable-area');
                        $(divToPrint).print({
                            globalStyles: true,
                            mediaPrint: false,
                            //stylesheet: direction_boolean ?  baseUrl + "/assets/css/print-styles-rtl.css" : baseUrl + "/assets/css/print-styles.css",
                            stylesheet: direction_boolean ? "/themes/custom/aawsatv3/assets/css/print-styles-rtl.css" : "/themes/custom/aawsatv3/assets/css/print-styles.css",
                            iframe: false,
                            noPrintSelector: ".no-print",
                            append: "",
                            prepend: "",
                            manuallyCopyFormValues: true,
                            deferred: $.Deferred(),
                            timeout: 750,
                            title: null,
                            doctype: '<!doctype html>'
                        });
                    });
                }
                // ========================  END:  PRINT ARTICLE ===========================//
            },

            jwplayerVideo: function () {
                // homepage jwplayer video

                var videoUrlId = "",
                    videoFile = "",
                    videoId = "";

                if ($(".video-player").length) {

                    //render all jwplayer
                    $('.video-player').each(function () {
                        videoUrlId = $(this).attr('data-video-id');

                        var jwplayerApi = "https://cdn.jwplayer.com/v2/media/" + videoUrlId;
                        // videoFile = "https://cdn.jwplayer.com/videos/" + videoUrlId + ".mp4";

                        fetch(jwplayerApi)
                            .then(response => response.json())
                            .then(responseData => {
                                var lastItem = responseData.playlist[0].sources.length - 1;
                                videoFile = responseData.playlist[0].sources[lastItem].file;

                                jwplayer(this.id).setup({
                                    //  image: videoImg,
                                    //aspectratio: "16:9",
                                    width: '100%',
                                    height: window.innerHeight,
                                    autostart: false,
                                    file: videoFile
                                });

                            })

                    });


                    $("#has-no-video").on("click", function () {
                        videoId = $("#has-video .jwplayer").attr("id");
                        $(this).hide();
                        $("#has-video").show();

                        stopToday();
                        stopOpinion();

                        jwplayer(videoId).play();
                    });


                    $("#videoTabs_js .tabs-panel.is-active .article-video").on("click", function () {
                        //if video is clicked close any open podcast  
                        stopToday();
                        stopOpinion();
                    });

                    // VIDEO SECTION ON HOMEPAGE 

                    $("#videoTabs_js .tabs-title a").on("click", function (e) {
                        e.preventDefault();

                        if ($(e.target).is("img") || $(e.target).is("h3")) {
                            var $thisID = $(this).attr('aria-controls');

                            // if there is currently playing video. pause it.
                            if ($("#videoTabs_js .jwplayer").length) {
                                var prevVideo = $("#videoTabs_js .tabs-panel.is-active").find(".jwplayer").attr('id');
                                // pause previous video;
                                jwplayer(prevVideo).pause();
                            }


                            videoId = $("#videoTabs_js #" + $thisID).find(".jwplayer").attr("id");

                            jwplayer(videoId).play();

                            $("#has-no-video").hide();
                            $("#has-video").show();

                            stopToday();
                            stopOpinion();

                        }

                    }); 

                    $('#videoTabsContent').on('change.zf.tabs', function () {
                        var tabId = $('div[data-tabs-content="'+$(this).attr('id')+'"]').find('.tabs-panel.is-active').attr('id');
 
                        if($('#'+tabId +':visible').length){

                            var currTabVidId = ($("#"+tabId).find(".jwplayer").attr("id"));
                             
                            if (jwplayer(currTabVidId).getState() == "buffering" || jwplayer(currTabVidId).getState() == "playing") {
                                $("#" + currTabVidId).on("click", function () { 
                                    stopToday();
                                    stopOpinion();
                                })
                            }
                        }

                    });

                }

            },

            layout: function () {
                // GO-TO SCRIPT -- start
                var $root = $('html, body');
                // SCROLL TO SECTION
                if ($('.goto_js').length > 0) {
                    //sticky go to 

                    var stickyBlock = new hcSticky('.goto_js', {
                        stickTo: '.content-wrap',
                        top: $(".main-header-inner").height(),
                        bottomEnd: 100,
                        stickyClass: 'hc-sticky'
                    });

                    // go to slide
                    $('.goto_js a[href^="#"]').on('click', function () {
                        var href = $.attr(this, 'href'); myElement4314636

                        $root.animate({
                            scrollTop: $(href).offset().top - 80
                        }, 500, function () {
                            // window.location.hash = href;
                        });

                        return false;
                    });

                    // on click
                    $('.goto_js a').on('click', function () {
                        $(".goto_js li").removeClass('active');
                        $(this).closest('li').addClass('active');
                    });

                    // on scroll
                    let menuScrollTimer = null;
                    $(window).on('scroll', function (e) {
                        // Avoid triggering the logic if the scroll event is triggerd from clicking one of the items
                        if (menuScrollTimer === null) {
                            let windowTop = $(this).scrollTop();

                            $('.goto_js a').each(function (event) {
                                if (windowTop >= $($(this).attr('href')).offset().top - 130) {
                                    $(".goto_js li").removeClass('active');
                                    $(this).closest('li').addClass('active');
                                }
                            });
                        }
                    });
                }
                // GO-TO SCRIPT -- end 

                // ========================  START: ENTRY CONTENT IFRAME ===========================//

                if ($('.entry-content').length > 0) {
                    var target = $('.entry-content').find('iframe').not('[src*="datawrapper"]').not('[src*="flo.uri.sh"]').not('[src*="polldaddy.com"]').not('.instagram-media').not('[src*="docs.google.com"]').not('[src*="cdn.jwplayer.com"]').not('[src*="facebook.com"]').not('[src*="twitter.com"]').not('[src*="arabnews.com"]').not('[src*="cdn.knightlab.com"]').not('[src*="//if-cdn.com"]');
                    target.wrap("<p class='responsive-embed widescreen'></p>");
                }

                // ========================  END: ENTRY CONTENT IFRAME ===========================//

              
               


                if ($('.newsletter-modal').length > 0) {
                    setTimeout(function () {
                        $('.newsletter-content .mailchimp-newsletter-mergefields, #edit-actions, #edit-actions--2').wrapAll('<div class="mailchimp-newsletter-subscribe"></div>');
                    }, 1000);
                }

                // ========================  START:  DYNAMIC HEIGHT IFRAME ===========================//
                if ($(".iframe-dynamic").length) {
                    var aemIframeResize = function (a) {
                        if (!isNaN(a.data)) {
                            var c = document.getElementsByClassName("iframe-dynamic");
                            c && (c[0].style.height = a.data + "px");
                        }
                    };
                    function resetIframe(a) {
                        if ("resetIframe" === a.data) {
                            if ((a = document.getElementsByClassName("iframe-dynamic"))) a[0].style.height = null;
                            a[0].contentWindow && a[0].contentWindow.postMessage("resetComplete", "*");
                        }
                    }
                    window.addEventListener("message", aemIframeResize, !1);
                    window.addEventListener("message", resetIframe, !1);
                }

                // ========================  END:  DYNAMIC HEIGHT IFRAME ===========================//

                // ========================  START:  SHOW PASSWORD  ===========================//
                if ($('.show-password').length) {
                    $(".show-password").on('click', function () {
                        var input = $(this).siblings('input');
                        $(this).toggleClass("is-shown");
                        $('i', this).toggleClass("icon-eye1 icon-eye");

                        if (input.attr("type") == "password") {
                            input.attr("type", "text");
                        } else {
                            input.attr("type", "password");
                        }
                    });
                }
                // ========================  END:  SHOW PASSWORD  ===========================//

                if ($(".register-wide__close").length) {
                    $(".register-wide__close").on("click", function () {
                        $(this).closest(".register-wide").fadeOut(500);
                    })
                }

                // User dropdown - add class to body when clicked open
                $('.user-dropdown').on("change", function () {
                    if ($('.user-dropdown').is(':checked')) {
                        $("body").addClass("user-open");
                    } else if (!$('.user-dropdown').is(':checked')) {
                        $("body").removeClass("user-open");
                    }
                })

            },

            // themeColor: function () {
            //     if ($("#detection").length) {
            //         const detectionDiv = document.querySelector('#detection');
            //         // If the computed style is not white then the page is in Auto Dark Theme.
            //         const isAutoDark = getComputedStyle(detectionDiv).backgroundColor != 'rgb(255, 255, 255)';
            //         // Update element styles when Auto Dark Theme is applied.
            //         if (isAutoDark) {
            //             const myElement = document.querySelector('body');
            //             myElement.classList.add('auto-dark-theme'); 
            //         }
            //     }  
            // },

            plugins: function () {
                // for sticky sidebar
                if ($('#sticky-block').length > 0) {
                    var stickyBlock = new hcSticky('#sticky-block', {
                        stickTo: '.sidebar-wrap',
                        top: 55,
                        bottomEnd: 100,
                        stickyClass: 'hc-sticky',
                        responsive: {
                            991: {
                                disable: true
                            }
                        }
                    });

                    setTimeout(function () {
                        stickyBlock.refresh();
                    }, 4000);
                }



                if (Foundation.MediaQuery.is('large') == true) {

                    if ($('.sticky-aside_js').length > 0) {
                        var stickySectionTitles = document.getElementsByClassName('sticky-aside_js');

                        for (var i = 0; i < stickySectionTitles.length; i++) {
                            var asideSticky = new hcSticky(stickySectionTitles[i], {
                                //stickTo: '.entry-article-inner', 
                                //stickyTo: '.sidebar-wrap',
                                stickTo: stickySectionTitles[i].parentNode.parentNode.parentNode,
                                top: 80
                            });

                        }
                    }

                    if ($('.sticky-block_js').length > 0) {
                        var stickySectionTitles = $('.sticky-block_js');

                        for (var i = 0; i < stickySectionTitles.length; i++) {
                            new hcSticky(stickySectionTitles[i], {
                                stickTo: stickySectionTitles[i].parentNode.parentNode.parentNode,
                                top: 80
                            });
                        }
                    }
                }
                // ========================  START: VERTICAL SLIDER (OPINION BLOCK) ===========================//

                if ($('.slider_js').length > 0) {
                    var $slider = $('.slider_js');

                    $slider.slick({
                        dots: true,
                        infinite: false,
                        speed: 300,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        rtl: direction_boolean,
                        responsiveClass: true,
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]

                    });
                }
                // ========================  END: VERTICAL SLIDER (OPINION BLOCK) ===========================//
                // ========================  START: CARICATURE SLIDER (BLOCK) ===========================//

                if (Foundation.MediaQuery.is('medium up') == true) {

                    if ($('.cari-slider_js').length > 0) {
                        var $cariSlider = $('.cari-slider_js');
                        $cariSlider.addClass("owl-carousel");
                        $cariSlider.owlCarousel({
                            margin: 20,
                            stagePadding: 10,
                            loop: false,
                            autoWidth: false,
                            items: 1,
                            dots: false,
                            rtl: direction_boolean,
                            responsiveClass: true,
                            responsive: {
                                // 390:{
                                //     nav: false,
                                //     dots: false
                                // },
                                480: {
                                    nav: false,
                                },
                                768: {
                                    nav: false
                                },
                                770: {
                                    nav: false,
                                    dots: true,
                                    stagePadding: 0,
                                }
                            }
                        });
                    }
                }
                // ========================  END: CARICATURE SLIDER (BLOCK) ===========================//

                // ========================  START: OPINION GRID SLIDER (MY-TAGS) ===========================//

                if ($('#op-grid-slider').length > 0) {
                    var $cariSlider = $('#op-grid-slider');
                    // if opinion items have more than 3 items proceed to slider view, else dont use slider.
                    if ($('#op-grid-slider > div').length > 6) {
                        $cariSlider.addClass("slick-loader");
                        if (Foundation.MediaQuery.is('small only') == true) {
                            var x = $('#op-grid-slider').children();

                            for (i = 0; i < x.length; i += 3) {
                                x.slice(i, i + 3).wrapAll('<div class="op-slider-item"></div>');
                            }

                        } else {
                            var x = $('#op-grid-slider').children();

                            for (i = 0; i < x.length; i += 2) {
                                x.slice(i, i + 2).wrapAll('<div class="op-slider-item"></div>');
                            }
                        }

                        $cariSlider.slick({
                            dots: true,
                            infinite: false,
                            speed: 300,
                            arrows: false,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            rtl: direction_boolean,
                            lazyLoad: 'ondemand',
                            responsive: [
                                {
                                    breakpoint: 520,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    }
                                }
                            ]
                        });
                    } else {
                        $cariSlider.addClass("grid-x grid-margin-x small-up-1 medium-up-3").removeClass("slick-loader");
                        $('#op-grid-slider .podcast-item').wrap("<div class='cell margin-bottom-1'></div>");
                    }
                }
                // ========================  END: OPINION GRID SLIDER (MY-TAGS) ===========================//

                // ========================  START:  MEDIA SLIDER (ARTICLE)===========================//
                var mediaSlider = $('.media-slider_js');
                var mediaImgHeight;
                var sliderContentHeight;
                mediaSlider.slick({
                    lazyLoad: 'progressive',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: true,
                    adaptiveHeight: true,
                    mobileFirst: true,
                    rtl: direction_boolean,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                swipe: false
                            }
                        }
                    ]
                });

                // ========================  END:  MEDIA SLIDER (ARTICLE)===========================//

                // ========================  START:  HERO SLIDER (HERO)===========================//
                var heroSlider = $('.hero-slider_js');

                heroSlider.slick({
                    lazyLoad: 'progressive',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    fade: true,
                    adaptiveHeight: true,
                    mobileFirst: true,
                    rtl: direction_boolean
                });

                // ========================  END:  HERO SLIDER (HERO)===========================//

                // ========================  START:  URL HASH CHANGE RUN THIS ===========================//

                let lastUrl = location.href;
                new MutationObserver(() => {
                    const url = location.href;
                    if (url !== lastUrl) {
                        lastUrl = url;
                        onUrlChange();
                    }
                }).observe(document, { subtree: true, childList: true });


                function onUrlChange() {
                    //console.log("urlchange");
                    personalization();

                    if ($(".articles-entries").length) {
                        if ($(".pageWrapper").hasClass("active")) {
                            let currArticle = $(".pageWrapper.active").find(".entry-article");

                            let currTitle = currArticle.attr("data-page-title") != undefined ? currArticle.attr("data-page-title") : "",
                                currArticleId = currArticle.attr("data-value") != undefined ? currArticle.attr("data-value") : "",
                                currCategory = currArticle.attr("data-article-category") != undefined ? currArticle.attr("data-article-category") : "",
                                currLength = $(".pageWrapper.active").find(".entry-article .entry-content p").text().length != undefined ? $(".pageWrapper.active").find(".entry-article .entry-content p").text().length : "",
                                currAuthor = currArticle.attr("data-article-author") != undefined ? currArticle.attr("data-article-author") : "",
                                currPubDate = currArticle.attr("data-article-publish-date") != undefined ? currArticle.attr("data-article-publish-date") : "",
                                currTags = currArticle.attr("data-tags") != undefined ? currArticle.attr("data-tags") : "";

                            window.dataLayer = window.dataLayer || [];

                            dataLayer.push({
                                event: 'dynamic_article_load',
                                article_id: currArticleId,
                                page_title: currTitle,
                                article_category: currCategory,
                                article_author: currAuthor,
                                article_length: currLength,
                                article_publish_date: currPubDate,
                                tags: currTags
                            });
                        };
                    }

                }


                personalization();
                // ========================  END:  URL HASH CHANGE RUN THIS===========================//

                function personalization() {

                    // ========================  START: VERTICAL SCROLLER ===========================//
                    var vContainer = $('.v-scroller_js'); // this holds init div for the content to be made scrollable


                    if (Foundation.MediaQuery.is('large') == true) {

                        vContainer.mCustomScrollbar({
                            axis: "y",
                            theme: "dark-thin",
                            //  autoExpandScrollbar:true,
                            scrollInertia: 400,
                            //advanced:{autoExpandHorizontalScroll:true}
                        });

                        $(".personal-wrap-before").mCustomScrollbar({
                            axis: "y",
                            theme: "dark-thin",
                            //  autoExpandScrollbar:true,
                            scrollInertia: 400,
                            //advanced:{autoExpandHorizontalScroll:true}
                        });
                    }


                    // ========================  END: VERTICAL SCROLLER ===========================//

                    if ($(".menu-tabs").length > 0) {
                        if (Foundation.MediaQuery.is('small only') == true) {
                            //my-profile tabs always close

                            if ($(".accordion-item.is-active").length) {
                                $('.menu-tabs').each(function () {
                                    var $acc = $(this);
                                    var $openSections = $acc.find('.accordion-item.is-active .accordion-content');
                                    $openSections.each(function (i, section) {
                                        $acc.foundation('up', $(section));
                                    });
                                });
                            }

                        }
                    }

                }

                // MODAL

                if ($(".modal-toggle").length > 0) {
                    var videoUrl = "",
                        videoTitle = "";
                    $('.modal-toggle').on('click', function (e) {
                        e.preventDefault();
                        var $this = "";
                        $this = $(this).data('id');
                        $('.modal-wrap[data-modal="' + $this + '"]').toggleClass('is-visible');
                        $('html').addClass("modal-open");


                        if ($(this).hasClass("video-item-share")) {
                            videoUrl = $(this).attr("data-share-url");
                            videoTitle = $(this).attr("data-title");
                            //$(".video-popup-modal-content.addthis_toolbox").attr("addthis:url", videoUrl);
                            $(".copy-link-input input[type='text']").val(videoUrl);
                            var url = $('.copy-link-input input').val();

                            $(".copy-link-input button, .copy-link-input input").on("click", function () {
                                copyUrl(url);
                            });

                            $('.wa-share').on("click", function (e) {
                                e.preventDefault();
                                window.open('https://api.whatsapp.com/send?text=' + videoTitle + ' ' + videoUrl,
                                    'newwindow',
                                    'width=300,height=250');
                            });

                            $('.tw-share').on("click", function (e) {
                                e.preventDefault();

                                window.open('https://twitter.com/share?text=' + videoTitle + '&url=' + videoUrl + '',
                                    'newwindow',
                                    'width=300,height=250');
                            });

                            $('.fb-share').on("click", function (e) {
                                e.preventDefault();

                                window.open('https://www.facebook.com/dialog/share?app_id=374745497486996&display=popup&href=' + videoUrl,
                                    'newwindow',
                                    'width=300,height=250');
                            });

                        }
                    });

                    $(".modal-close, .touch-close").on('click', function (e) {
                        e.preventDefault();
                        $(this).closest('.modal-wrap').toggleClass('is-visible');
                        $('html').removeClass("modal-open");
                    });
                }

                //game-modal
                if (Foundation.MediaQuery.is('small only') == true) {
                    if ($(".game-modal-toggle").length > 0) {

                        $('.game-modal-toggle').on('click', function (e) {
                            e.preventDefault();
                            var $this = "";
                            $this = $(this).data('id');
                            $('.modal-wrap[data-modal="' + $this + '"]').toggleClass('is-visible');
                            $('html').addClass("modal-open");
                        });
                    }
                }


                function copyUrl(url) {
                    const textToCopy = url;
                    navigator.clipboard.writeText(textToCopy).then(
                        function () {
                            /* clipboard successfully set */
                            $(".copy-link-input").addClass("copied");
                        },
                        function () {
                            /* clipboard write failed */
                            window.alert('Opps! Your browser does not support the Clipboard API')
                        }
                    )
                }


                $(document).on('mouseout', '.copied', function () {
                    $(this).removeClass('copied');
                });

                // ========================  START:  STICKY LIVE BLOG ===========================//

                function stickyLive() {
                    if ($("#start-live").length > 0) {
                        if (Foundation.MediaQuery.is('large') == true) {
                            var waypoint = new Waypoint({
                                element: document.getElementById('start-live'),
                                handler: function (direction) {
                                    //console.log(direction, 'Basic waypoint triggered');
                                    console.log((this.element.id + ' triggers at ' + this.triggerPoint))
                                    if (direction == "down") {
                                       // $("#hero-live > div").css({ opacity: 1.0, visibility: "visible" }).animate({ opacity: 0 }, 'slow');
                                        // $("#hero-side > div").fadeIn().removeClass("hide"); 
                                        $("#hero-side").removeClass('sou').addClass("sod");
                                    }
                                    if (direction == "up") {
                                       // $("#hero-live > div").css({ opacity: 0, visibility: "visible" }).animate({ opacity: 1 }, 'slow');
                                        //$("#hero-side > div").fadeOut("slow").addClass("hide"); 
                                        $("#hero-side").removeClass("sod").addClass("sou");
                                    }

                                    //console.log(this.element.clientHeight, 'clientheight');

                                },
                                offset: '30%'
                                // offset: function () {
                                //     return $('.header-sticky').height() + 80; 
                                // }
                            })
                        }
                    }
                }
                stickyLive();

                $(window).on('resize', function () {
                    stickyLive();
                });
                // ========================  END:  STICKY LIVE BLOG ===========================//

                // ========================  START:  MY-TAGS-V2 page ===========================//
                if ($(".cat_js").length > 0) {

                    categoryScroll();
                    // custom tabs
                    if (Foundation.MediaQuery.is('small') == true) {
                        $('.c-tabs_js a').on('click', function () {
                            $(".c-tab-content_js").removeClass('tab-active');
                            $(".c-tab-content_js[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
                            $('.c-tabs_js a').removeClass('is-active');
                            $(this).parent().find("a").addClass('is-active');
                            categoryScroll();
                        });


                        var $category = $('.c-tabs_js');
                        var $headerHeight = "";
                        if ($(".header-tag-wrap").length) {
                            $headerHeight = $(".main-header-inner").outerHeight() + $(".header-tag-wrap").height();
                        } else {
                            var $headerHeight = $(".main-header-inner").outerHeight();
                        }
                        $category.hcSticky({
                            stickTo: 'main',
                            top: $headerHeight,
                            bottomEnd: 100,
                            stickyClass: 'hc-sticky'
                        });

                        var lastScrollTop = 0;
                        $(window).on("scroll", function () {
                            var st = $(this).scrollTop();
                            if (st > lastScrollTop) {
                                // downscroll code  
                                $category.hcSticky('update', {
                                    top: $(".main-header-inner.header-sticky").outerHeight()
                                });

                            } else {
                                // upscroll code  
                                if (st == 0) {
                                    $category.hcSticky('update', {
                                        top: $headerHeight
                                    });

                                }
                            }
                            lastScrollTop = st;
                        });

                    }

                    if (Foundation.MediaQuery.is('large') == true) {
                        // scroll inside div
                        var lastScrollTop = 0;
                        var top = $(".category-menu").offset().top;
                        $(".vertical-scroll").on("scroll", function () {
                            var st = $(this).scrollTop();

                            if (st > lastScrollTop) {
                                // downscroll code 
                                //if($(".vertical-scroll").scrollTop() > top) {     
                                $(this).find(".category-menu").addClass("fixed");
                                // }
                            } else {
                                // upscroll code 
                                if (st == 0) {
                                    $(this).find(".category-menu").removeClass("fixed");
                                }
                            }
                            lastScrollTop = st;
                        });
                    }

                }
                function categoryScroll() {
                    $(".cat_js").each(function () {
                        var parentCategoryWidth = $(this).closest(".section-content").width();
                        var categoryTagsWidth = $(this)[0].scrollWidth;

                        if (categoryTagsWidth > parentCategoryWidth) {
                            $(this).addClass("owl-carousel cat_js");
                            $(this).owlCarousel({
                                margin: 0,
                                loop: false,
                                autoWidth: true,
                                //items:4,
                                dots: false,
                                rtl: direction_boolean,
                                nav: true,
                                responsiveClass: true,
                                responsive: {
                                    390: {
                                        nav: false
                                    },
                                    480: {
                                        nav: false
                                    },
                                    768: {
                                        nav: false
                                    },
                                    770: {
                                        nav: true
                                    }
                                }
                            });
                        }

                    });
                }
                // ========================  END:  MY-TAGS-V2 page ===========================//

                // ========================  START:  ON MOBILE: ALWAYS LOAD FROM TOP ===========================//

                if (Foundation.MediaQuery.is('small only') == true) {

                    if (history.scrollRestoration) {
                        history.scrollRestoration = 'manual';
                    } else {
                        window.onbeforeunload = function () {
                            window.scrollTo(0, 0);
                        }
                    }

                }
                // ========================  END:  ON MOBILE: ALWAYS LOAD FROM TOP ===========================//

                // FONT ADJUSTMENT SLIDER 

                if ($('.fntChange_js').length > 0) {

                    //default fontsize
                    //$('.fntChange_js').css('background', 'linear-gradient(to '+direction_opposite+', #000000 ' + value + '%, #DCEBE9 0%)' );

                    $('.fntChange_js').each(function (e) {

                        $(".font-size").text($('.fntChange_js')[0].value);

                        $(this).on('input', function (e) {

                            $(this).closest('.entry-article').find("p").css('font-size', $(e.target).val() + 'px');
                            $(this).closest('.entry-article').find("p + h3").css('font-size', (parseInt($(e.target).val()) + 2) + 'px');

                            var value = ($(this).val() - $(this).attr("min")) / ($(this).attr("max") - $(this).attr("min")) * 100;
                            //$(this).css('background', 'linear-gradient(to right, #0f1414 0%, #233231 ' + value + '%, #2C8A82 100%)' );
                            $(this).css('background', 'linear-gradient(to ' + direction_opposite + ', #000000 ' + value + '%, #DCEBE9 0%)');
                            //console.log(value, 'valueee');
                            //$(this).css('background', 'linear-gradient(90deg, #DCEBE9 '+value+'%, black '+value+'%);' );
                            $(this).closest(".font-control").find(".font-size").text($(e.target).val());

                            if ($('.sticky-aside_js').length) {
                                asideSticky.refresh();
                            }

                            if ($('#sticky-block').length) {
                                stickyBlock.refresh();
                            }


                            // PASS VALUE TO GA4

                            let currFontVal = $(this)[0].value;
                            let currArticle = $(".pageWrapper.active").find(".entry-article");

                            let currCategory = currArticle.attr("data-article-category") != undefined ? currArticle.attr("data-article-category") : "",
                                currArticleId = currArticle.attr("data-value") != undefined ? currArticle.attr("data-value") : "",
                                currLength = $(".pageWrapper.active").find(".entry-article .entry-content p").text().length != undefined ? $(".pageWrapper.active").find(".entry-article .entry-content p").text().length : "",
                                currAuthor = currArticle.attr("data-article-author") != undefined ? currArticle.attr("data-article-author") : "",
                                currPubDate = currArticle.attr("data-article-publish-date") != undefined ? currArticle.attr("data-article-publish-date") : "",
                                currTags = currArticle.attr("data-tags") != undefined ? currArticle.attr("data-tags") : "";

                            window.dataLayer = window.dataLayer || [];

                            dataLayer.push({
                                event: 'font_change',
                                article_id: currArticleId,
                                font_size: currFontVal,
                                article_category: currCategory,
                                article_author: currAuthor,
                                article_length: currLength,
                                article_publish_date: currPubDate,
                                tags: currTags
                            });


                        });

                    });

                    if (Foundation.MediaQuery.is('medium down') == true) {
                        //on mobile - font change toggle changes to show hide 
                        $('.fntChange-btn_js').each(function () {
                            $(this).on('click', function () {
                                $(this).siblings(".slider-control_js").slideToggle("slow").toggleClass('close open');
                            })
                        })

                        // when clicked outside the font change toggle hide input range
                        $(document).on('click', function (e) {
                            if ($(e.target).closest(".fntChange-btn_js").length === 0 && $('.slider-control_js').hasClass('open')) {
                                $('.fntChange-btn_js').siblings(".slider-control_js").slideUp("slow").removeClass('open').addClass('close');
                            }
                        });
                    }

                }

                // ==================== END PLUGINS =======================
            },

            analytics: function () {
                // GOOGLE ANALYTICS

                window.call_google_analytics = function () {
                    var trackURL = jQuery(location).attr("pathname");
                    //console.log(trackURL);
                    if (trackURL != 'undefined') {
                        try {
                            trackClickView(trackURL);
                        } catch (e) {
                            console.log(e);
                        }

                        try {
                            refreshEM(trackURL);
                        } catch (e) {
                            console.log(e);
                        }
                    }
                }

            },

            cookies: function () {
                if ($.cookie('cookie-overlay') == 'agree') //if the cookie exists with the value 'agree', no popup
                {

                    // console.log('The cookie is still valid, no popup today!');

                }
                //  else if ($.cookie('cookie-overlay') == 'disagree') {

                //     $(".cookie-overlay").hide();

                // } 
                else //if there's no cookie, fire the popup, then give them a cookie
                {
                    //console.log('The cookie is null, you get a popup');

                    $(".cookie-overlay--large").toggle(); //show the popup by toggling away its display-none status


                    $(".cookie-close, .btn-disagree").on('click', function () { //toggle the popup when close button is hit
                        $(this).closest(".cookie-overlay").fadeOut();
                        $(window).off("scroll");
                    });


                    // $(".btn-disagree").on('click', function () { //toggle the popup when disagree button is hit
                    //     $(".cookie-overlay").hide();
                    //     $.cookie('cookie-overlay', 'disagree', { expires: 1 });
                    //     $(window).off("scroll");
                    // });

                    $(".btn-agree").on("click", function () {
                        // add cookie script
                        $.cookie('cookie-overlay', 'agree', { expires: 1, path: '/' }); //this is the cookie, named popup with the value agree, expires after 1 day and is relevant to the whole site. see 'jquery-cookie' documentation for more details: https://github.com/carhartl/jquery-cookie
                        $(".cookie-overlay").fadeOut();
                        $(window).off("scroll");
                    });


                    // on scroll 
                    if (Foundation.MediaQuery.is('large') == true) {
                        var lastScrollTop = 0;
                        $(window).on("scroll", function () {
                            var st = $(this).scrollTop();
                            if (st > lastScrollTop) {
                                // downscroll code  
                                $(".cookie-overlay--large").hide();
                                $(".cookie-overlay--small").fadeIn();

                            } else {
                                $(".cookie-overlay--large").fadeIn();
                                $(".cookie-overlay--small").hide();
                            }
                            lastScrollTop = st;
                        });
                    }


                }


            }


        }

    };

    $(document).ready(function () { engineUtils.init(); });


})(jQuery); 